<app-header sectionName="Supplier Settings"></app-header>

<div class="page">
  @if (loading) {
  <div class="center"><mat-spinner diameter="32"></mat-spinner></div>
  } @else {

  <mat-card class="card">
    <h3>Default fees</h3>
    @if (fees) {
    <p class="formula">
      Unit: currency per <b>{{ fees.coin_unit | number }}</b> coins.
      <code>{{ fees.formula }}</code>
    </p>
    }

    @if (fees && !fees.default_stock_fee_set) {
    <p class="unset">
      <mat-icon>warning</mat-icon>
      No default stock fee is set. Suppliers cannot add accounts until one is configured.
    </p>
    }
    @if (fees && !fees.default_manual_contract_fee_set) {
    <p class="unset">
      <mat-icon>warning</mat-icon>
      No default manual-contract fee is set. Suppliers cannot create contracts until one is configured.
    </p>
    }

    <div class="fields">
      <mat-form-field appearance="outline">
        <mat-label>Default stock fee</mat-label>
        <input matInput type="number" min="0" [(ngModel)]="stockFee" placeholder="unset">
        <mat-hint>Snapshotted onto each new account.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Default manual-contract fee</mat-label>
        <input matInput type="number" min="0" [(ngModel)]="contractFee" placeholder="unset">
        <mat-hint>Snapshotted onto each new supplier contract.</mat-hint>
      </mat-form-field>
    </div>

    <p class="note">
      Changing a default affects <b>new</b> records only. Existing stocks and contracts keep
      the rate they were created with, and every past transfer run keeps the rate it
      snapshotted when it was claimed — so settled earnings are never rewritten.
    </p>

    @if (canEdit) {
    <button mat-flat-button color="primary" [disabled]="savingFees" (click)="saveFees()">
      {{ savingFees ? 'Saving…' : 'Save fees' }}
    </button>
    }
  </mat-card>

  @if (portal) {
  <mat-card class="card">
    <h3>Supplier portal</h3>
    <p class="note">Shown on the supplier portal's public landing page and dashboard.</p>

    <div class="fields">
      <mat-form-field appearance="outline">
        <mat-label>Open-webapp price (per 100k coins)</mat-label>
        <input matInput type="number" min="0" [(ngModel)]="portal.open_webapp_price">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Closed-webapp price (per 100k coins)</mat-label>
        <input matInput type="number" min="0" [(ngModel)]="portal.closed_webapp_price">
      </mat-form-field>
    </div>

    <div class="toggle-row">
      <mat-slide-toggle [(ngModel)]="portal.buying_enabled">Buying enabled</mat-slide-toggle>
      <p class="note">
        Off blocks <b>new</b> work only — suppliers cannot arm accounts or create contracts.
        Transfers already running continue to completion, so nothing is stranded mid-drain.
      </p>
    </div>

    <p class="note">Leave a URL blank to remove that link from the supplier portal.</p>

    <div class="fields">
      <mat-form-field appearance="outline">
        <mat-label>Telegram support URL</mat-label>
        <input matInput [(ngModel)]="portal.telegram_support_url" placeholder="https://t.me/…">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Tutorials URL</mat-label>
        <input matInput [(ngModel)]="portal.tutorials_url">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Sales site URL</mat-label>
        <input matInput [(ngModel)]="portal.sales_site_url">
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Dashboard notice (HTML)</mat-label>
      <textarea matInput rows="4" [(ngModel)]="portal.notice_html" placeholder="&lt;p&gt;…&lt;/p&gt;"></textarea>
      <mat-hint>Rendered as-is at the top of every supplier's dashboard. Leave blank to show nothing.</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Payment notice (plain text)</mat-label>
      <textarea matInput rows="3" [(ngModel)]="portal.payment_notice"
        placeholder="e.g. Payments are made every Saturday."></textarea>
      <mat-hint>Shown to every supplier on their Payments page, above the payment request button. Leave blank to show nothing.</mat-hint>
    </mat-form-field>

    @if (canEdit) {
    <button mat-flat-button color="primary" [disabled]="savingPortal" (click)="savePortal()">
      {{ savingPortal ? 'Saving…' : 'Save portal settings' }}
    </button>
    }
  </mat-card>
  }
  }
</div>
